function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "g10",
  transform: "matrix(1.3333333,0,0,-1.3333333,0,197.98667)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g12",
  transform: "scale(0.1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path14",
  d: "M77.2,1201.5H37.5v252.3l39.7-2.6V1201.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path16",
  d: "M142.2,1201.5h-39.7v179.9l39.7-2.2V1201.5z M122.3,1436.2c12.5,0,22.7-10.2,22.7-22.7 c0-12.5-10.2-22.7-22.7-22.7c-12.5,0-22.7,10.2-22.7,22.7C99.6,1425.9,109.8,1436.2,122.3,1436.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "path18",
  d: "M236.9,1345.2v-39.7h-29.8v-103.9h-39.7V1399c0,30.1,25,57.3,54.4,57.3c9.9,0,17.9-2.9,19.8-4.2 l-1.6-38.1h-18.2c-8,0-14.7-6.7-14.7-15v-53.8H236.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path20",
  d: "M292.7,1310.7h29.8v18.6c0,8.3-6.7,15-14.7,15c-8.3,0-15-6.7-15-15V1310.7z M253,1329.2 c0,30.1,24.3,54.7,54.7,54.7c30.1,0,54.4-24.6,54.4-54.7v-38.4c0-11.2-9-19.8-19.8-19.8h-49.6v-17.3c0-8.3,6.7-15,15-15h38.1 l1.3-33.6l-35.9-5.4c-34.6-5.8-58.3,24-58.3,54.1V1329.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "path22",
  d: "M396.1,1201.5v250.7h25.6V1376c7,2.2,18.2,3.2,25.9,3.2c27.2,0,48.3-24.6,48.3-52.5v-125.2h-25 v125.2c0,13.8-11.2,24.7-25,24.7h-24.3v-149.8H396.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path24",
  d: "M589.7,1249.8v43.2H565c-13.8,0-24.6-10.9-24.6-24.6v-18.6c0-13.8,10.9-25,24.6-25 C578.8,1224.9,589.7,1236.1,589.7,1249.8z M589.7,1330.8c0,14.4-6.7,25.9-25,24h0.3c-10.2-0.3-23.4-1.6-34.3-2.2 c-0.3,9.3-0.6,12.8-1,19.8c8.6,3.2,21.1,6.4,31.7,6.7c32,0.6,53.1-25.3,53.1-53.1v-76.2c0-27.5-22.1-50.3-49.6-50.3 c-27.5,0-50.3,22.7-50.3,50.3v15.7c0,27.5,18.9,48.3,50.3,48.3c11.8,0,17.9-1.3,24.7-3.2V1330.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "path26",
  d: "M686.4,1379.2c27.5,0,50.3-22.4,50.3-50.3v-3.2c-9.9-0.3-17.9-0.3-25.3-0.6v3.8 c0,13.4-11.2,24.6-25,24.6c-13.4,0-24.3-11.2-24.3-24.6v-80c0-14.1,10.9-24.7,24.3-24.7c13.4,0,24.7,10.2,25,23.7 c12.5-1,24.3-1.6,25.3-1.6c-1.3-26.6-23.7-47.7-50.3-47.7c-27.5,0-49.9,22.4-49.9,50.3v80C636.4,1356.8,658.8,1379.2,686.4,1379.2 "
}), /*#__PURE__*/React.createElement("path", {
  id: "path28",
  d: "M837.5,1201.5l-48.7,84.8c-4.8,8.3-4.8,9.3,1,19.2l42.9,71.1h29.1l-48.3-82l52.2-93.2H837.5z  M782.5,1451.5v-250h-25.6v250H782.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path30",
  d: "M896.7,1301.7H946v26.9c0,13.8-11.2,25-24.7,25c-13.8,0-24.7-11.2-24.7-25V1301.7z M871.1,1328.6 c0,27.8,22.4,50.6,50.3,50.6c27.5,0,49.9-22.7,49.9-50.6v-39.4c0-7.4-5.8-12.8-12.8-12.8h-61.8v-27.2c0-13.8,10.9-25,24.7-25h32.3 c0.3-8.3,0.6-14.1,1.3-19.8l-30.7-4.8c-31.4-5.4-53.1,21.8-53.1,49.6L871.1,1328.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path32",
  d: "M1019.4,1201.5h-25.6v124.8c0,27.9,21.8,53.8,53.8,53.1c10.9-0.3,17.6-2.9,25-6.4 c-0.3-7.7-0.6-14.1-1-19.8l-27.9,0.6c-13.4,0-24.3-14.4-24.3-27.5V1201.5"
})));

var SvgLifeHackerLogo = function SvgLifeHackerLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147 44",
    style: {
      enableBackground: "new 0 0 147 44"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLifeHackerLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LifeHacker-Logo.08fd6dc1.svg";
export { ForwardRef as ReactComponent };